import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Translate, withLocalize } from 'react-localize-redux';
import { useLocation } from 'react-router';
import PulseLoader from 'react-spinners/PulseLoader';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';

import Helmet from '../../components/common/Helmet';
import LinkComponent from '../../components/common/LinkComponent';
import Input from '../../components/form/Input';
import { emailRegex, passwordRegex } from '../../helpers/regex';
import { ontee } from '../../services';

function ResetPasswordContainer({ translate }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const { search } = useLocation();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm();

  useEffect(() => {
    document.body.classList.add('new-site', 'reset');
    const params = new URLSearchParams(search);
    setValue('email', params.get('email'));
    setValue('code', params.get('code'));

    return () => {
      document.body.classList.remove('new-site', 'reset');
    };
  }, [search, setValue]);

  const onSubmit = async data => {
    try {
      setIsLoading(true);
      setSuccess(false);
      setError(false);

      await ontee.auth.resetPassword({
        Email: data.email,
        Code: data.code,
        Password: data.password,
        ConfirmPassword: data.confirmPassword,
      });
      setSuccess(true);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet
        titleTranslationKey="ResetPasswordContainer"
        descriptionTranslationKey="ResetPasswordContainerText"
      />

      <div className="d-flex">
        <Container className="p-0 mt-4">
          <Card>
            <CardHeader className="pt-5 px-3 px-sm-5">
              <h1>
                <Translate id="ResetPasswordContainer" />
              </h1>
            </CardHeader>
            <CardBody className="px-3 pt-0 px-sm-5">
              <form onSubmit={handleSubmit(onSubmit)}>
                <input type="hidden" name="code" />
                <Row>
                  <Col>
                    <Input
                      name="email"
                      label={translate('default.Email')}
                      autoComplete="email"
                      readOnly
                      register={register}
                      rules={{ required: true, pattern: emailRegex }}
                      error={errors.email && translate('errorInvalidEmail')}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input
                      name="password"
                      type="password"
                      label={translate('default.Password')}
                      autoComplete="off"
                      register={register}
                      rules={{ required: true, pattern: passwordRegex }}
                      error={errors.password && translate('Register.form.password.error')}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Input
                      name="confirmPassword"
                      type="password"
                      label={translate('default.ConfirmPassword')}
                      autoComplete="off"
                      register={register}
                      rules={{ required: true, validate: value => value === getValues('password') }}
                      error={errors.confirmPassword && translate('Register.form.cPassword.error')}
                    />
                  </Col>
                </Row>

                <div className="text-end mt-1">
                  {success && (
                    <p className="text-success">
                      <Translate id="ResetPasswordContainerSuccess" />
                    </p>
                  )}
                  {error && <div className="mb-1 text-danger">{error.message || error}</div>}
                  <Button color="success" type="submit" disabled={isLoading}>
                    {isLoading ? (
                      <PulseLoader size={10} color="#fff" />
                    ) : (
                      <Translate id="default.Send" />
                    )}
                  </Button>
                  <div className="text-end mt-2">
                    <LinkComponent to="signin/">
                      <Translate id="default.SignIn" />
                    </LinkComponent>
                  </div>
                </div>
              </form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
}

export default withLocalize(ResetPasswordContainer);
